export default {"src":"/_next/static/media/default_1.a9e7538d.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};